// ScrollContainer.js - 基类组件
import React from 'react';
import { withRouter } from 'react-router-dom'
import { universitiesList } from './Universities'

import Header from './components/header.jsx';
import Footer from './components/footer.jsx';

import LazyImage from './components/lazyImage.jsx';



class University extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            activeMenu: 'liuxue',//liuxue,uk,usa,au,language,culture
            data_list: []
        };

        universitiesList.map(countryItem => {
            countryItem.universities.map(item => {

                this.state.data_list.push({ ...item, country: countryItem.country, country_code: countryItem.country_code, })
            })
        });
    }

    componentDidMount() {
        const { match } = this.props;
        const { id } = match.params;

        let universitiyInfo = this.state.data_list.find(a => a.university_code == id);
        this.setState({ universitiyInfo });

    }




    render() {
        let { universitiyInfo } = this.state;
        let arrayImgs = [];
        if (universitiyInfo) {
            for (var i = 0; i < universitiyInfo.photoNumbers; i++) {
                arrayImgs.push(universitiyInfo.photoNumbers);
            }

        }

        return (
            <div className={`flex-col`}>
                <Header activeMenu='7' />
                <div className='dv_project_body dv_unviersty_wrap'>
                    <div className='dv_project_body_left'>
                        <div className='dv_project_fixed_left'>
                            {universitiyInfo && <div className='flex-col dv_universty_name_wrap'>
                                <img src={require(`./assets/img/unviserty/${universitiyInfo.background_image}`)} className='dv_unversity_logo' />
                                {/* <span className='dv_universty_name'>{universitiyInfo.country}</span> */}
                            </div>}
                            <div className="dv_title_gradient">大学简介</div>
                            {universitiyInfo && <div className="dv_title_description">{universitiyInfo.introduction}</div>}
                        </div>
                    </div>
                    <div className='dv_project_body_right '>
                        {universitiyInfo && <div className='flex-col d-flex-center dv_body_right_rap'>
                            {
                                arrayImgs.map((o, index) => {
                                    if (index == 0) {
                                        return (<div className='dv_top_banner'><span className='dv_schoolName_title'>{universitiyInfo.name}</span><img src={require("./assets/img/unviserty/" + universitiyInfo.university_code + "/" + index + ".jpg")} /></div>)
                                    } else {
                                        return (<LazyImage imgUrl={require("./assets/img/unviserty/" + universitiyInfo.university_code + "/" + index + ".jpg")} />)
                                    }

                                })}
                        </div>
                        }

                    </div>

                </div>
                <Footer />
            </div>
        );
    }
}

export default withRouter(University);